import {NgModule, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicModule, IonicErrorHandler} from 'ionic-angular';
import {MyApp} from './app.component';

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {ComponentsModule} from '../components/components.module';

import {HomePage} from '../pages/home/home';
import {TabsPage} from '../pages/tabs/tabs';
import {BookingsPage} from "../pages/bookings/bookings";
import {TrendingCutsPage} from "../pages/trending-cuts/trending-cuts";
import {ProfilePage} from "../pages/profile/profile";
import {DiscoveryFeedMapPage} from "../pages/discovery-feed-map/discovery-feed-map";
import {ShopPage} from "../pages/shop/shop";
import {AdvancedBookingsPage} from "../pages/advanced-bookings/advanced-bookings";
import {AdvancedBookingsTimePage} from "../pages/advanced-bookings-time/advanced-bookings-time";
import {DiscoveryFeedListPage} from "../pages/discovery-feed-list/discovery-feed-list";
import {TrendingCutPage} from "../pages/trending-cut/trending-cut";
import {ProfileAccountDetailsPage} from "../pages/profile-account-details/profile-account-details";
import {ProfilePasswordPage} from "../pages/profile-password/profile-password";
import {ProfileLoginPage} from "../pages/profile-login/profile-login";
import {ProfileCreateAccountPage} from "../pages/profile-create-account/profile-create-account";
import {ServicesPage} from "../pages/services/services";
import {ServiceSummaryPage} from "../pages/service-summary/service-summary";
import {ServiceSuccessPage} from "../pages/service-success/service-success";
import {NativeGeocoder} from "@ionic-native/native-geocoder";
import {LocationServiceProvider} from '../providers/location-service/location-service';
import {Geolocation} from "@ionic-native/geolocation";
import {CancelModalPage} from "../pages/cancel-modal/cancel-modal";
import {ProfileForgotPasswordPage} from "../pages/profile-forgot-password/profile-forgot-password";
import {ProfileDeleteAccountModalPage} from "../pages/profile-delete-account-modal/profile-delete-account-modal";
import {CalendarModule} from "ion2-calendar";
import {LobbyPage} from "../pages/lobby/lobby";
import {LobbyDisplayPage} from "../pages/lobby-display/lobby-display";
import {MyChairPage} from "../pages/my-chair/my-chair";
import {NoShowModalPage} from "../pages/no-show-modal/no-show-modal";
import {UserNotesModalPage} from "../pages/user-notes-modal/user-notes-modal";
import {CompleteBookingModalPage} from "../pages/complete-booking-modal/complete-booking-modal";
import {AdditionalServiceSuccessPage} from "../pages/additional-service-success/additional-service-success";
import {CustomerNameModalPage} from "../pages/customer-name-modal/customer-name-modal";
import {CancelledBookingsPage} from "../pages/cancelled-bookings/cancelled-bookings";

import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptorProvider} from '../providers/api-interceptor/api-interceptor';
import {IonicStorageModule} from '@ionic/storage';
import {ApiErrorHandlerProvider} from '../providers/api-error-handler/api-error-handler';
import {Dialogs} from "@ionic-native/dialogs";

import {Camera} from '@ionic-native/camera';
import {Push} from '@ionic-native/push';
import {PipesModule} from "../pipes/pipes.module";
import {LobbyScreensaverPage} from "../pages/lobby-screensaver/lobby-screensaver";
import {DurationPipe} from "../pipes/duration/duration";
import {Device} from "@ionic-native/device";
import {PushNotificationServiceProvider} from '../providers/push-notification-service/push-notification-service';
import {TimezoneProvider} from '../providers/timezone/timezone';
import {AppVersion} from "@ionic-native/app-version";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {StripeServiceProvider} from '../providers/stripe-service/stripe-service';
import {PaymentsPage} from "../pages/payments/payments";
import {PaymentHistoryPage} from "../pages/payment-history/payment-history";
import {PaymentMethodsPage} from "../pages/payment-methods/payment-methods";
import {PaymentNewCardPage} from "../pages/payment-new-card/payment-new-card";
import {PaymentPage} from "../pages/payment/payment";
import {TabsServiceProvider} from '../providers/tabs-service/tabs-service';
import {RegisterGuestServiceProvider} from '../providers/register-guest-service/register-guest-service';
import {PaymentChangeMethodPopoverPage} from "../pages/payment-change-method-popover/payment-change-method-popover";
import {ServiceQuantityModal} from "../pages/service-quantity-modal/service-quantity-modal";
import {CountryProvider} from '../providers/country/country';
import {AdditionalServiceSummaryPage} from "../pages/additional-service-summary/additional-service-summary";
import {StaffServiceProvider} from '../providers/staff-service/staff-service';
import {TeamServiceProvider} from '../providers/team-service/team-service';
import {BookingServiceProvider} from '../providers/booking-service/booking-service';
import {StaffDashboardPage} from "../pages/staff-dashboard/staff-dashboard";
import {MyChairMultipleShopPage} from "../pages/my-chair-multiple-shop/my-chair-multiple-shop";
import {CheckinPopoverPage} from "../pages/checkin-popover/checkin-popover";
import {AppServiceProvider} from '../providers/app-service/app-service';
import {SearchPage} from "../pages/search/search";
import {ShopListingPage} from "../pages/shop-listing/shop-listing";
import {UserServiceProvider} from '../providers/user-service/user-service';
import {LoyaltyRewardsPage} from "../pages/loyalty-rewards/loyalty-rewards";
import {LoyaltyRewardsBarbershopPage} from "../pages/loyalty-rewards-barbershop/loyalty-rewards-barbershop";
import {NgCircleProgressModule} from "ng-circle-progress";
import {LoyaltyInfoPopoverPage} from "../pages/loyalty-info-popover/loyalty-info-popover";
import {LoyaltyServiceProvider} from "../providers/loyalty-service/loyalty-service";
import {InviteBarbershopPage} from "../pages/invite-barbershop/invite-barbershop";
import {RecommendationThankYouPopoverPage} from "../pages/recommendation-thank-you-popover/recommendation-thank-you-popover";
import { TermsConditionsServiceProvider } from '../providers/terms-conditions-service/terms-conditions-service';
import {ShopStaffHoursPopoverPage} from "../pages/shop-staff-hours-popover/shop-staff-hours-popover";
import { SearchServiceProvider } from '../providers/search-service/search-service';
import {SearchResultsPage} from "../pages/search-results/search-results";
import {TermsPage} from "../pages/terms/terms";
import { UrlServiceProvider } from '../providers/url-service/url-service';
// import {SentryIonicErrorHandler} from "../providers/sentry-ionic-error-handler/sentry-ionic-error-handler";
import { ProfilePromoProductsPage } from '../pages/profile-promo-products/profile-promo-products';
import { ProfilePromoProductPage } from '../pages/profile-promo-product/profile-promo-product';
import { PromoInfoPage } from '../pages/promo-info/promo-info';
import { CoffeShopPage } from '../pages/coffe-shop/coffe-shop';
import { CoffeShopServicePage } from '../pages/coffe-shop-service/coffe-shop-service';
import { CoffeShopPaymentPage } from '../pages/coffe-shop-payment/coffe-shop-payment';
import { CoffeShopService } from '../providers/coffe-shop/coffe-shop.service';
import { DirectivesModule } from '../directives/directives.module';
import { CoffeShopEditPage } from '../pages/coffe-shop-edit/coffe-shop-edit';
import { ReschedulePage } from '../pages/reschedule/reschedule';
import { BarberBookingNewPage } from '../pages/barber-booking-new/barber-booking-new';
import { ShopNewPage } from '../pages/shop-new/shop-new';
import { NgCalendarModule  } from 'ionic2-calendar';
import { BookingDetails } from '../pages/booking-details/booking-details';
import { FavouritesPage } from '../pages/favourites/favourites';
import { BookingsHoursPage } from '../pages/bookings-hours/bookings-hours';
import { MessengerPage } from '../pages/messenger/messenger';
import { ChatPage } from '../pages/chat/chat';
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
    BookingsPage,
    TrendingCutsPage,
    ProfilePage,
    ProfileAccountDetailsPage,
    ProfilePasswordPage,
    ProfileLoginPage,
    ProfileCreateAccountPage,
    PromoInfoPage,
    ProfilePromoProductsPage,
    ProfilePromoProductPage,
    ProfileForgotPasswordPage,
    ProfileDeleteAccountModalPage,
    DiscoveryFeedMapPage,
    ShopPage,
    ShopNewPage,
    AdvancedBookingsPage,
    AdvancedBookingsTimePage,
    DiscoveryFeedListPage,
    TrendingCutPage,
    ServicesPage,
    ServiceSummaryPage,
    ServiceSuccessPage,
    CancelModalPage,
    LobbyPage,
    LobbyDisplayPage,
    LobbyScreensaverPage,
    MyChairPage,
    NoShowModalPage,
    UserNotesModalPage,
    CompleteBookingModalPage,
    CustomerNameModalPage,
    CancelledBookingsPage,
    PaymentsPage,
    FavouritesPage,
    BookingsHoursPage,
    PaymentHistoryPage,
    PaymentMethodsPage,
    PaymentNewCardPage,
    PaymentPage,
    PaymentChangeMethodPopoverPage,
    ServiceQuantityModal,
    AdditionalServiceSummaryPage,
    AdditionalServiceSuccessPage,
    StaffDashboardPage,
    MyChairMultipleShopPage,
    CheckinPopoverPage,
    SearchPage,
    ShopListingPage,
    LoyaltyRewardsPage,
    LoyaltyRewardsBarbershopPage,
    LoyaltyInfoPopoverPage,
    InviteBarbershopPage,
    RecommendationThankYouPopoverPage,
    ShopStaffHoursPopoverPage,
    SearchResultsPage,
    TermsPage,
    CoffeShopPage,
    CoffeShopServicePage,
    CoffeShopPaymentPage,
    CoffeShopEditPage,
    ReschedulePage,
    BarberBookingNewPage,
    BookingDetails,
    MessengerPage,
    ChatPage
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    PipesModule,
    DirectivesModule,
    HttpClientModule,
    IonicStorageModule,
    CalendarModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: ''
        }
      }
    }),
    NgCircleProgressModule.forRoot({
      // @ts-ignore
      "outerStrokeGradientStopColor": "#5EB1BF",
      "startFromZero": false,
      "lazy": false
    }),
    NgCalendarModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TabsPage,
    BookingsPage,
    TrendingCutsPage,
    ProfilePage,
    ProfileAccountDetailsPage,
    ProfilePasswordPage,
    ProfileLoginPage,
    ProfileCreateAccountPage,
    PromoInfoPage,
    ProfilePromoProductsPage,
    ProfilePromoProductPage,
    ProfileForgotPasswordPage,
    ProfileDeleteAccountModalPage,
    DiscoveryFeedMapPage,
    ShopPage,
    ShopNewPage,
    AdvancedBookingsPage,
    AdvancedBookingsTimePage,
    DiscoveryFeedListPage,
    TrendingCutPage,
    ServicesPage,
    ServiceSummaryPage,
    ServiceSuccessPage,
    CancelModalPage,
    LobbyPage,
    LobbyDisplayPage,
    LobbyScreensaverPage,
    MyChairPage,
    NoShowModalPage,
    UserNotesModalPage,
    CompleteBookingModalPage,
    CustomerNameModalPage,
    CancelledBookingsPage,
    PaymentsPage,
    FavouritesPage,
    BookingsHoursPage,
    PaymentHistoryPage,
    PaymentMethodsPage,
    PaymentNewCardPage,
    PaymentPage,
    PaymentChangeMethodPopoverPage,
    ServiceQuantityModal,
    AdditionalServiceSummaryPage,
    AdditionalServiceSuccessPage,
    StaffDashboardPage,
    MyChairMultipleShopPage,
    CheckinPopoverPage,
    SearchPage,
    ShopListingPage,
    LoyaltyRewardsPage,
    LoyaltyRewardsBarbershopPage,
    LoyaltyInfoPopoverPage,
    InviteBarbershopPage,
    RecommendationThankYouPopoverPage,
    ShopStaffHoursPopoverPage,
    SearchResultsPage,
    TermsPage,
    CoffeShopPage,
    CoffeShopServicePage,
    CoffeShopPaymentPage,
    CoffeShopEditPage,
    ReschedulePage,
    BarberBookingNewPage,
    BookingDetails,
    MessengerPage,
    ChatPage
  ],
  providers: [
    Device,
    Push,
    DurationPipe,
    StatusBar,
    SplashScreen,
    Dialogs,
    NativeGeocoder,
    Geolocation,
    LocationServiceProvider,
    TimezoneProvider,
    ApiErrorHandlerProvider,
    // {
    //   provide: ErrorHandler,
    //   useClass: SentryIonicErrorHandler
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorProvider,
      multi: true
    },
    ApiErrorHandlerProvider,
    Camera,
    PushNotificationServiceProvider,
    TimezoneProvider,
    AppVersion,
    InAppBrowser,
    StripeServiceProvider,
    InAppBrowser,
    TabsServiceProvider,
    RegisterGuestServiceProvider,
    CountryProvider,
    StaffServiceProvider,
    TeamServiceProvider,
    BookingServiceProvider,
    AppServiceProvider,
    LoyaltyServiceProvider,
    UserServiceProvider,
    TermsConditionsServiceProvider,
    SearchServiceProvider,
    UrlServiceProvider,
    CoffeShopService
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts